import { render, staticRenderFns } from "./IDTMenu.vue?vue&type=template&id=06f0c514&scoped=true&"
import script from "./IDTMenu.vue?vue&type=script&lang=js&"
export * from "./IDTMenu.vue?vue&type=script&lang=js&"
import style0 from "./IDTMenu.vue?vue&type=style&index=0&id=06f0c514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0c514",
  null
  
)

export default component.exports